import { render, staticRenderFns } from "./PingtalkPersonalWhatsapp.vue?vue&type=template&id=fd63a578&"
import script from "./PingtalkPersonalWhatsapp.vue?vue&type=script&lang=js&"
export * from "./PingtalkPersonalWhatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports